import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/features/bookmarks.webp")